import React from "react";

import ResponsiveChart from "components/RunPlot/ResponsiveChart";

import { BarChart, Bar, CartesianGrid, Tooltip, XAxis, YAxis, ResponsiveContainer, Label, Cell } from "recharts";

import styles from "./style.module.css";

class CustomToolTip extends React.Component {
  render() {
    const { active, payload, hasProb, label, successStrings } = this.props;
    if (!active || !payload || !payload[0] || !payload[0].payload) {
      return null;
    }

    return;
    <div className={styles.cTooltip}>
      <div className={styles.tModel}>{payload[0].payload.value}</div>
      <div className={styles.tBody}>
        <div className={styles.tLabel}>{"Prediction: "}</div>
        <strong>{"ew"}</strong>
      </div>
      {payload.map((p, index) => (
        <div className={styles.tBody} key={index}>
          <div className={styles.tLabel}>{p.name + ": "}</div>
          <strong>{p.value}</strong>
        </div>
      ))}
    </div>;
  }
}

const CustomLabel = (props) => {
  const { active, payload, label } = props;

  return (
    <text textAnchor="start" className={styles.aLabel} onClick={() => {}}>
      <tspan
        x={
          props.position === "insideTopLeft"
            ? props.value
              ? 250 / props.value.length
              : 20
            : props.viewBox.x + props.viewBox.width / 2 - 33
        }
        y={props.viewBox.y + props.offset}
      >
        {props.value}
      </tspan>
    </text>
  );
};

const RenderLegend = (props) => {
  const { successStrings } = props;

  return (
    <div className={styles.legendHolder}>
      <div className={styles.legendItem}>
        <div className={styles.legendIcon + " " + styles.positive} />
        <div>{successStrings.positive}</div>
      </div>
      <div className={styles.legendItem}>
        <div className={styles.legendIcon + " " + styles.negative} />
        <div>{successStrings.negative}</div>
      </div>
    </div>
  );
};

function toFixed(num, fixed) {
  var re = new RegExp("^-?\\d+(?:.\\d{0," + (fixed || -1) + "})?");
  return num.toString().match(re)[0];
}

class InteractionGraph extends React.Component {
  render() {
    const { updateSelected, interactions, onHover, datasetId } = this.props;

    if (datasetId === undefined) {
      return <div className={styles.emptyMsg}>{"No Dataset Selected"}</div>;
    }

    const retInteractions = interactions
      .map((p) => ({
        ...p,
        oldScore: Math.abs(p.data.score),
        Score: Math.abs(p.data.weightedScore).toFixed(6),
        label:
          p.data.fields[0].replace(new RegExp(" ", "g"), "_") +
          "&&" +
          p.data.fields[1].replace(new RegExp(" ", "g"), "_")
      }))
      .sort((a, b) => {
        let aSort = a.Score;
        let bSort = b.Score;

        return aSort < bSort ? 1 : aSort > bSort ? -1 : 0;
      })
      .filter((p, i) => i < 15);

    const xLabel = "Interactions";
    const yLabel = "Score";

    const yDataMin = Math.min.apply(
      Math,
      retInteractions.map((p) => p.score)
    );
    const yDataMax = Math.max.apply(
      Math,
      retInteractions.map((p) => p.score)
    );
    const yDelta = yDataMax - yDataMin;

    const yOffset = 0.001;

    const yDomain = [
      Math.max(0, yDataMin - Math.abs(yDelta) - yOffset),
      Math.min(100, yDataMax + Math.abs(yDelta) + yOffset)
    ];

    let values = {};
    let models = {};

    const colors = [
      "#512F77",
      "#472F77",
      "#3E2F77",
      "#342F77",
      "#2F3377",
      "#2F3D77",
      "#2F4777",
      "#5B2F77",
      "#642F77",
      "#6E2F77",
      "#772F77",
      "#772F6D"
    ];

    let maxChars = xLabel ? xLabel.length - 10 : 0;

    retInteractions &&
      retInteractions.forEach((p) => {
        const val = p.field;

        if (val && val.toString().length > maxChars) {
          maxChars = val.toString().length;
        }
      });

    return (
      <div className={styles.pChart} id="pChart">
        <ResponsiveContainer>
          <BarChart
            margin={{
              top: 40,
              right: 20,
              bottom: 20,
              left: maxChars * 5
            }}
            layout="vertical"
            data={retInteractions}
            onClick={(data) => {
              if (
                data &&
                data.activePayload &&
                data.activePayload.length > 0 &&
                data.activePayload[0].payload &&
                data.activePayload[0].payload.data &&
                data.activePayload[0].payload.data.fields &&
                data.activePayload[0].payload.data.fields.length === 2
              ) {
                const fields = data.activePayload[0].payload.data.fields;

                return updateSelected({
                  [fields[0]]: true,
                  [fields[1]]: true
                });
              }
            }}
          >
            <YAxis type="category" dataKey={"label"} name={xLabel}>
              <Label value={xLabel} position={"top"} />
            </YAxis>
            <XAxis type="number" dataKey={"Score"} name={yLabel} domain={yDomain}>
              <Label style={{ pointerEvents: "none" }} value={yLabel} offset={0} position="bottom" />
            </XAxis>
            <CartesianGrid strokeDasharray="3 3" />
            <Tooltip tooltip={<CustomToolTip />} />
            <Bar dataKey={"Score"}>
              {retInteractions.map((p, index) => (
                <Cell key={`cell-${index}`} fill={colors[0]} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  }
}

export default ResponsiveChart(InteractionGraph);
